import { DIALOGSEARCH } from "../../actions/portal/";

export default function(state = false, action){
  switch (action.type) {
    case DIALOGSEARCH:
    return action.payload;
    default:
  }

  return state;
}
